module.exports = __webpack_public_path__ + "static/media/no_credit_packs.8255b9a5.png";